import { all, call, put, takeLatest } from 'redux-saga/effects';
import { api } from 'services';
import {
  history,
  LOADING,
  ASYNC_CREATE_MARKETING_PLAN,
  ASYNC_EDIT_MARKETING_PLAN,
  ASYNC_CHANGE_STATUS_MARKETING_PLAN,
  ASYNC_LANDING_APPROVAL
} from 'store';
import { toast } from 'react-toastify';
import swal from '../../helpers/swal';

function* createMarketingPlan({ payload }) {
  yield put({ type: LOADING, payload: true });

  try {
    const response = yield call(api.post, 'marketing-plans', payload, {
      headers: {
        'X-Success-Message': 'Plano criado com sucesso!',
        // 'X-Redirect': `/marketing-plans/`,
        'X-Show-Alert': true
      }
    });
    window.location.href = `/marketing-plans/edit/${response.data.id}`;
  } catch (error) {
    yield swal('Ops!', error.response.data[0], 'error');
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* editMarketingPlan({ payload }) {
  yield put({ type: LOADING, payload: true });

  try {
    yield call(api.put, `marketing-plans/${payload.id}`, payload, {
      headers: {
        'X-Success-Message': payload.message_alert, 
        'X-Redirect': '/marketing-plans',
        'X-Show-Alert': true
      }
    });
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* changeStatusMarketingPlan({ payload }) {
  yield put({ type: LOADING, payload: true });

  try {
    yield call(api.post, 'marketing-plans/approve', payload, {
      headers: {
        'X-Success-Message': payload.get('message_alert'), 
        'X-Redirect': '/marketing-plans',
        'X-Show-Alert': true
      }
    });
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* landingPageApproval({ payload }) {
  yield put({ type: LOADING, payload: true });
  try {
    yield call(api.post, 'marketing-plans/approve', payload, {
      headers: {
        'X-Success-Message': 'Sua avaliação foi enviada com sucesso', 
        'X-Redirect': '/marketing-plans',
        'X-Show-Alert': true
      }
    });
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

export default function* root() {
  yield all([
    takeLatest(ASYNC_CREATE_MARKETING_PLAN, createMarketingPlan),
    takeLatest(ASYNC_EDIT_MARKETING_PLAN, editMarketingPlan),
    takeLatest(ASYNC_CHANGE_STATUS_MARKETING_PLAN, changeStatusMarketingPlan),
    takeLatest(ASYNC_LANDING_APPROVAL, landingPageApproval)
  ]);
}
